import { ReactElement } from 'react';
import { Page } from '@client/app/components/App/Page';
import { FACET_FILTERS } from '@client/catalog/utils/facets';
import { useTranslate } from '@client/i18n/hooks';
import { useScrollRestore } from 'b2b-apps/core/app/context/ScrollRestoreContext';
import { Catalog } from '../../../Catalog';
import { Brand } from './Brand';
import { Props } from './';
import './BrandPage.scss';

export const BrandPage = ({
  title,
  isBrandVisible,
}: Props): ReactElement => {
  const t = useTranslate();
  const scrollContext = useScrollRestore();

  return (
    <Page className='BrandPage' title={title || t('Brand')}>
      <Catalog
        title={title}
        hiddenSections={[FACET_FILTERS.manufacturer]}
        isLevelZeroAvailable
        getScrollPosition={scrollContext.getScrollPosition}
      >
        {isBrandVisible ? <Brand brand={title} /> : null}
      </Catalog>
    </Page>
  );
};
